import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { GOButton } from "../../../components";
import { actionPutEmployeeLessonTime } from "../../../stores/actions";
import * as Styled from "./styles";
import dayjs from "dayjs";
import ScheduleManageDetailBox from "../ScheduleManageDetailBox";
import { useTranslation } from "react-i18next";

interface LessonTimeProps {
  data: any;
  date: any;
  update: boolean;
}

const ScheduleManageDetail = (props: LessonTimeProps) => {
  const { t } = useTranslation();
  const data = props.data.workTimes?.slice().sort((a: any, b: any) => {
    return a["day"] - b["day"];
  });

  return (
    <Styled.Container>
      {props.update ? (
        <Styled.ViewBox>
          <ScheduleManageDetailBox
            selectedDayIndex={props.date}
            workTimes={data}
            employID={props.data.employee.id}
          />
        </Styled.ViewBox>
      ) : (
        <Styled.ViewBox>
          <Styled.Text>{t("components.employee.selectWeekDay")}</Styled.Text>
        </Styled.ViewBox>
      )}
    </Styled.Container>
  );
};

export default ScheduleManageDetail;
